import { DisplayMessage } from '@core/app/scripts/services/display-message';

export class MessageManager {
  constructor($q: ng.IQService, displayMessage: DisplayMessage) {}

  sendInfo = (message: string) => {
    const deferred = this.$q.defer();

    this.displayMessage.message({
      message,
      type: 'info',
      callback: () => deferred.resolve(),
      mini: false,
    });

    return deferred.promise;
  };

  sendError = (message: string) => {
    const deferred = this.$q.defer();

    this.displayMessage.message({
      message,
      type: 'alert',
      callback: () => deferred.resolve(),
      mini: false,
    });

    return deferred.promise;
  };

  sendPrompt = (message: string) => {
    const deferred = this.$q.defer();

    this.displayMessage.message({
      message,
      type: 'prompt',
      callback: (response) => {
        if (response === 'yes') {
          deferred.resolve();
        } else {
          deferred.reject();
        }
      },
      mini: false,
    });

    return deferred.promise;
  };
}

/*
 * Service messageManager. Meant to brige legacy displayMessage & notificationManager form v7/share
 */
angular.module('posApp').factory('messageManager', ($q, displayMessage) => {
  return new MessageManager($q, displayMessage);
});
